import { ReservationStatusEnum } from "../../enums/reservation-status.enum";

export class ReservationModel {
  public id: string;
  public userId: string;
  public firstName: string;
  public lastName: string;
  public reservationDateAndTime: string;
  public numberOfGuests: number;
  public status: ReservationStatusEnum;
  public phone: string;
  public email: string;
  public comment: string;
  public venueId: string;
  public declinedComment: string;
  public canceledComment: string;
  public mobileUserCategoryName: string;
  public hasPriority: boolean;
  public hostName: string;
  public leaveDateTime: string;
  public seatDateTime: string;
  public amount: number;
  public tips: number;
  public priorityNumber: number;
}
